import gettext from 'gettextjs';
import Immutable from 'immutable';

const headers = Immutable.fromJS({"project-id-version":"gettextjs","po-revision-date":"2015-10-26 09","last-translator":"Jonas Obrist <ojiidotch@gmail.com>","language":"en","mime-version":"1.0","content-type":"text/plain; charset=UTF-8","content-transfer-encoding":"8bit","plural-forms":"nplurals=2; plural=(n != 1);"});
const messages = Immutable.fromJS({"":["Project-Id-Version: gettextjs\nPO-Revision-Date: 2015-10-26 09:11+0000\nLast-Translator: Jonas Obrist <ojiidotch@gmail.com>\nLanguage: en\nMIME-Version: 1.0\nContent-Type: text/plain; charset=UTF-8\nContent-Transfer-Encoding: 8bit\nPlural-Forms: nplurals=2; plural=(n != 1);\n"],"simple-string":["A simple string"],"singular-string":["Singular form!","Plural form!"]});
const plural = n => ((n != 1)) * 1;

export default new gettext.Translations(headers, messages, plural);


// WEBPACK FOOTER //
// ./demo/src/locales/en/LC_MESSAGES/messages.mo